import { render, staticRenderFns } from "./centered.vue?vue&type=template&id=77c2433a&scoped=true"
import script from "./centered.vue?vue&type=script&lang=js"
export * from "./centered.vue?vue&type=script&lang=js"
import style0 from "./centered.vue?vue&type=style&index=0&id=77c2433a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c2433a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EsMessage: require('/home/runner/work/flash-ui/flash-ui/components/EsMessage.vue').default,EsLogo: require('/home/runner/work/flash-ui/flash-ui/components/EsLogo.vue').default})
